import { OauthFlowParams } from '../../complete/state/complete_state';
export interface FinishState {
  originalParams: OauthFlowParams;
};

export const initialFinishState: FinishState = {
  originalParams: {
    finalize_url: ''
  }
};

